import { CartLinesUpdateEvent } from '@shopify/events';

let adding = false;
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-top-upsell]')) return;
  event.preventDefault();
  if (adding) return;
  adding = true;
  const button = form.querySelector('button');
  const error = form.querySelector('[role="alert"]');
  button.disabled = true;
  button.textContent = 'Adding…';
  error.hidden = true;
  const pending = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: [{ merchandiseId: form.elements.id.value, quantity: 1 }],
    promise: pending.promise,
  }));
  try {
    const body = new FormData(form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))];
    body.set('sections', sections.join(','));
    body.set('sections_url', window.location.pathname);
    const response = await fetch(form.action, { method: 'POST', body, headers: { Accept: 'application/json' } });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
    const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) {
      window.location.assign(Theme.routes.cart_url);
      return;
    }
    const cart = await cartResponse.json();
    pending.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {
      sections: result.sections, items: cart.items, itemCount: cart.item_count, didError: false, source: 'top-cart-upsells',
    } });
  } catch (failure) {
    pending.resolve({ detail: { didError: true } });
    error.textContent = failure.message || 'Unable to add this item. Please try again.';
    error.hidden = false;
  } finally {
    adding = false;
    button.disabled = false;
    button.textContent = 'Add';
  }
});

// Keep wallets one tap away on mobile and immediately visible on desktop.
class TopCartExpress extends HTMLElement {
  connectedCallback() {
    this.media = window.matchMedia('(min-width: 750px)');
    this.sync = () => { this.querySelector('details').open = this.media.matches; };
    this.sync();
    this.media.addEventListener('change', this.sync);
  }
  disconnectedCallback() {
    this.media?.removeEventListener('change', this.sync);
  }
}
if (!customElements.get('top-cart-express')) customElements.define('top-cart-express', TopCartExpress);
